// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { DecisionNode_abstract } from './../abstract/SagaBase/DecisionNode_abstract';
export class DecisionNode extends DecisionNode_abstract {}
